import React from "react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Copy, RefreshCw } from "lucide-react";
import { copyToClipboard } from "../../utils/clipboard";
import RegenerateSection from "./RegenerateSection";

function PodcastTab({ content, onRegenerate, isRegenerating, onRegenerateItem, regeneratingItem }) {
  const copyAll = () => {
    const allText = content.map(section => 
      `${section.section}\n${section.points.map(p => `• ${p}`).join('\n')}`
    ).join("\n\n");
    copyToClipboard(allText);
  };

  if (!content || content.length === 0) {
    return (
      <div className="text-center text-white/60 py-12">
        <p className="mb-4">No podcast content generated yet.</p>
        {onRegenerate && <RegenerateSection onRegenerate={onRegenerate} isRegenerating={isRegenerating} contentType="Podcast" />}
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6 animate-fadeIn">
      {/* Header */}
      <div className="text-center space-y-2">
        <h2 className="text-3xl font-bold text-white">Podcast Episode Outline</h2>
        <p className="text-white/60">{content.length} sections • ~27 minutes total</p>
      </div>

      {/* Sections */}
      <div className="space-y-4">
        {content.map((section, index) => (
          <Card
            key={index}
            className={`card ${
              index % 2 === 0 ? "bg-white/3" : "bg-white/5"
            }`}
          >
            <CardContent className="pt-6">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 text-3xl">
                  🎙️
                </div>
                <div className="flex-1 space-y-3">
                  <div className="flex items-center justify-between">
                    <h3 className="text-xl font-bold text-white">
                      {section.section}
                    </h3>
                    <div className="flex items-center gap-2">
                      {onRegenerateItem && (
                        <button
                          onClick={() => onRegenerateItem(index)}
                          disabled={regeneratingItem === index}
                          className="p-1 rounded hover:bg-white/10 text-white/40 hover:text-white transition-colors"
                          title="Regenerate this section"
                        >
                          <RefreshCw size={13} className={regeneratingItem === index ? 'animate-spin' : ''} />
                        </button>
                      )}
                      <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => copyToClipboard(
                          section.section + "\n" + section.points.map(p => `• ${p}`).join("\n")
                        )}
                        className="text-[#00d4aa] hover:bg-[#00d4aa]/10"
                      >
                        <Copy className="w-3 h-3" />
                      </Button>
                    </div>
                  </div>
                  <ul className="space-y-2">
                    {section.points.map((point, i) => (
                      <li key={i} className="flex items-start gap-3 text-white/80">
                        <span className="text-[#00d4aa] font-bold">•</span>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Copy All Button */}
      <Button
        onClick={copyAll}
        className="w-full bg-[#00d4aa] hover:bg-[#00e6bb] text-black font-semibold h-12"
      >
        <Copy className="w-4 h-4 mr-2" />
        Copy Full Outline
      </Button>

      {/* Regenerate Section */}
      {onRegenerate && (
        <RegenerateSection
          onRegenerate={() => onRegenerate('podcast')}
          isRegenerating={isRegenerating}
          contentType="Podcast"
        />
      )}
    </div>
  );
}

export default PodcastTab;